import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        jdmn.log("event_esc-key.js initialized", "green");

        $(window).on("keyup", function (_e) {
            if (_e.key == "Escape") {
                $(window).trigger("escKey");
            }
        });
    });
})();
